export default __webpack_public_path__ + "static/media/service-img.95966fb4.png";